import * as actionTypes from './actionTypes';

export const getCarriers = () => ({
  type: actionTypes.GET_CARRIERS_REQUEST,
  requestType: 'GET',
  successType: actionTypes.GET_CARRIERS_SUCCESS,
  errorType: actionTypes.GET_CARRIERS_ERROR,
  url: '/carrier?limit=100',
});
